<script setup lang="ts">
  import { MpSelect } from '@borg/ui';
  import { CalculatorMode } from '@borg/types';

  const props = defineProps<{
    mode: CalculatorMode;
  }>();

  const { t } = useI18n();
  const navOptions = [
    { value: 'salary', label: t(`CALCULATORS_NAVIGATION.SALARY_CALCULATOR_LINK_LABEL`) },
    { value: 'author', label: t(`CALCULATORS_NAVIGATION.AUTHOR_CALCULATOR_LINK_LABEL`) },
    { value: 'service', label: t(`CALCULATORS_NAVIGATION.SERVICE_CALCULATOR_LINK_LABEL`) },
  ];
  const selected = ref(navOptions.filter((a) => a.value === props.mode)[0]);

  function onChange() {
    if (selected.value) {
      navigate({
        name: `calculator-${selected.value.value}`,
      });
    }
  }
</script>

<template>
  <div class="calc-nav__mobile">
    <MpSelect
      v-model="selected"
      :unselectable="false"
      :options="navOptions"
      :label="$t('CALCULATORS_NAVIGATION.NAVIGATOR_TITLE')"
      @update:model-value="onChange()"
    />
  </div>
</template>
